import { centToDollar } from "../../../data/utils";
import { isObligatoryOption, isKioskIncludedOption, isOptionDeprecated } from "./plans";
import capitalize from 'lodash/capitalize'

export const getCartDataObject = (cart) => {
  const planData = cart?.plan;  
  const planNameFormatted = planData?.name.replace("_join_now", "").replace("_1_year", "").replace("_3_year", "");
  const prices = planData?.prices || [];
  const plan = {
    planName: `${capitalize(planNameFormatted)} Plan`,
    planId: planData?.id,
    planPrice: prices.find(price => price.price_type === 'monthly')?.cents || 0,
    prices,
  }
  
  const addOns = [];
  const obligatoryOptionsList = [];
  const cartLines = [];
  const shippingFeesDetails = [];
  for(const line of cart?.cart_lines || []) {

    // First we add the shipping fees details to the state.
    if(line?.shipping_price) {
      shippingFeesDetails.push({
        name: line?.item?.display_name,
        price: line?.shipping_price,
      })
    }

    // Then we add the add ons details to the state.
    if(isOptionDeprecated(line?.item)) continue;

    if(isObligatoryOption(line?.item)) {
      obligatoryOptionsList.push(line?.item?.display_name);
      continue;
    }

    // For updating the cart lines by adding or removing add ons we need to keep the cart lines in the state without the obligatory options (included on the plan) and the shipping fees.
    cartLines.push({
      item: line?.item?.id,
      quantity: line?.quantity,
    });

    if(isKioskIncludedOption(line?.item)) {
      obligatoryOptionsList.push(line?.item?.display_name);
      continue;
    }
    const addOnPrice = line?.total_monthly_cents || line?.total_upfront_cents || 0;
    addOns.push({
      name: line?.item?.display_name,
      id: line?.item?.id,
      quantity: line?.quantity,
      // Since the API calculate all the prices, the Addons option will be separated by monthly and upfront so we could only have one value, i mean if the user has a monthly addon, the upfront price will be 0.
      price: addOnPrice,
      priceLabel: `$${centToDollar(addOnPrice)}${line?.total_monthly_cents ? '/mo' : ''}`,
  });
  }

  const summaryData = cart?.summary;
  const summaryWithoutDiscountData = cart?.summary_without_discounts;
  const summary = {
    totalAmount: summaryData?.monthly_cents + summaryData?.upfront_cents,
    totalAmountWithoutDiscount: summaryWithoutDiscountData?.monthly_cents + summaryWithoutDiscountData?.upfront_cents,
    total: summaryData,
    withoutDiscount: summaryWithoutDiscountData,
    discounts: {
      monthly_cents: (summaryWithoutDiscountData?.monthly_cents || 0) - (summaryData?.monthly_cents || 0),
      upfront_cents: (summaryWithoutDiscountData?.upfront_cents || 0) - (summaryData?.upfront_cents || 0),
      processing: summaryWithoutDiscountData?.processing ? {
        cents: (summaryWithoutDiscountData?.processing?.cents || 0) - (summaryData?.processing?.cents || 0),
        percents: (Number(summaryWithoutDiscountData?.processing?.percents || "0") - Number(summaryData?.processing?.percents || "0")).toFixed(2),
      } : null,
      online_and_events: summaryWithoutDiscountData?.online_and_events ? {
        cents: (summaryWithoutDiscountData?.online_and_events?.cents || 0) - (summaryData?.online_and_events?.cents || 0),
        percents: (Number(summaryWithoutDiscountData?.online_and_events?.percents || "0") - Number(summaryData?.online_and_events?.percents || "0")).toFixed(2),
      } : null,
    }
  }

  return {
      plan,
      addOns,
      obligatoryOptionsList,
      cartLines,
      shippingFeesDetails,
      nextPaymentDate: cart?.next_payment_date,
      summary,
  };
}